<template>
  <div>
    <top-bar @changeEmpresa="changeEmpresa()"/>
    <div class="content">
      <div class="bg-light">
        <div class="container-fluid px-0">
          <div class="row no-gutters">
            <div class="col-md-5 col-xl-4 bg-white lebot-contatos" :class="{'closed': dados}">
              <div class="lebot-filter">
                <div class="d-flex rounded position-relative" style="margin-bottom: 13px">
                  <div class="w-100 pr-2">
                    <i class="fa fa-search" style="position: absolute; top: 11px; left: 11px"></i>
                    <input id="atendiment" type="search" placeholder="Pesquisar contato" @search="buscarContatos()" v-model="pesquisa.termo"
                           class="form-control border-0 rounded bg-lebot" style="padding-left: 36px"/>
                  </div>
                  <div v-show="pesquisa.relatorio === '7'">
                    <button class="btn text-muted" @click="openMenu = !openMenu" @blur="openMenu = false"><i class="fa fa-ellipsis-v"></i></button>
                    <div class="menu-card" v-if="openMenu">
                      <div class="card border shadow rounded-sm">
                        <a href="javascript:" class="menu-item" @mousedown="ignorarTodos()">
                          <i class="fa fa-ban mr-1" style="width: 20px"></i> Ignorar todos
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="text-center">
                  <button class="btn mr-2" :class="pesquisa.relatorio === '7' ? 'btn-primary' : 'bg-lebot'" @click="toggleMenuFilter('7')">Aguardando</button>
                  <button class="btn px-4" :class="pesquisa.relatorio === '1' ? 'btn-primary' : 'bg-lebot'" @click="toggleMenuFilter('1')">Todos</button>
                </div>
              </div>
              <div class="lebot-contatos-body">
                <loading v-if="load" class="pt-5"/>
                <div v-else>
                  <a href="javascript:" class="lebot-contact text-dark text-decoration-none" v-for="c in contacts"
                     :class="{'selected': c.id_chatbot_user === dados}" :key="c.id" @click="selContato(c.id_chatbot_user)">
                    <div class="d-flex justify-content-between align-items-center">
                      <div class="lebot-contact-body">
                        <h6 class="mb-1 text-ellipsis" v-if="c.nome_user">{{ c.nome_user }}</h6>
                        <h6 class="mb-1 text-ellipsis" v-if="!c.nome_user">{{ c.telefone | phone }}</h6>
                        <div>
                          <span class="badge border font-weight-normal mr-1">{{c.ultima_msg}}</span>
                          <span class="badge badge-info" v-if="c.data_atendimento">Aguardando</span>
                          <span class="badge badge-primary" v-else-if="c.status === '1'">Ativo</span>
                          <span class="badge badge-secondary" v-else-if="c.status === '2'">Pausado</span>
                          <span class="badge badge-danger" v-else>Bloqueado</span>
                        </div>
                      </div>
                      <div class="text-nowrap text-right" v-if="c.data_atendimento">
                        <button class="btn btn-secondary mr-1" title="Ignorar atendimento" @click.stop="selAtendimento(c, true)"><i class="fa fa-ban"></i></button>
                        <button class="btn btn-primary" title="Aceitar atendimento" @click.stop="selAtendimento(c)"><i class="fa fa-check"></i></button>
                      </div>
                      <div class="text-nowrap text-right" v-else>
                        <button class="btn btn-danger mr-1" v-show="c.status !== '3'" title="Bloquear Bot" @click.stop="editarStatus(c, '3')"><i class="fa fa-stop"></i></button>
                        <button class="btn btn-info" v-show="c.status !== '1'" title="Ativar Bot" @click.stop="editarStatus(c, '1')"><i class="fa fa-play"></i></button>
                        <button class="btn btn-secondary" v-show="c.status === '1'" title="Pausar Bot" @click.stop="editarStatus(c, '2')"><i class="fa fa-pause"></i></button>
                      </div>
                    </div>
                  </a>
                </div>
              </div>
              <div class="lebot-contatos-footer d-md-flex border-top" :class="{'d-none': load || (pesquisa.page === 0 && contacts.length < pesquisa.bloco)}">
                <button class="btn btn-sm small" @click="paginateContacts(-1)" :disabled="pesquisa.page === 0"><i class="fa fa-angle-left"></i> Voltar</button>
                <span class="small" v-show="pesquisa.page">Página: {{pesquisa.page + 1}}</span>
                <button class="btn btn-sm small" @click="paginateContacts(1)" :disabled="contacts.length < pesquisa.bloco">Próximo <i class="fa fa-angle-right"></i></button>
              </div>
            </div>
            <div class="col-md-7 col-xl-8 lebot-dados" :class="{'opened': dados}">
              <cliente-formulario ref="contato" @editarContato="editarContato" @goHome="$emit('goHome')" @close="dados = null" class="pt-3 px-3" :token="token"/>
              <div class="lebot-welcome" v-if="!dados">
                <div>
                  <div class="logo">
                    <img src="../assets/icon.png" class="img-fluid" alt="Logo Lecard">
                  </div>
                  <p class="mt-4 mb-0">Seus contatos são sincronizados aqui.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import TopBar from "@/components/commons/TopBar";
import Loading from "@/components/commons/Loading";
import ModalMenu from "@/components/commons/ModalMenu";
import ClienteFormulario from "@/components/clientes/ClienteFormulario";
export default {
  components: {ClienteFormulario, ModalMenu, Loading, TopBar},

  data() {
    return {
      token: localStorage.getItem('key'),
      src: null,
      load: false,
      contacts: [],
      dados: null,
      openMenu: false,
      pesquisa: {
        relatorio: '7',
        termo: '',
        bloco: 30,
        page: 0
      }
    }
  },

  methods: {
    buscarContatos() {
      if (this.load) {
        return;
      }

      this.load = true
      this.contacts = [];
      this.pesquisa.relatorio = this.pesquisa.termo.length ? '1' : this.pesquisa.relatorio;

      if (this.empresaAtual && this.empresaAtual.id_empresa) {
        this.$store.dispatch('clearAtendimentosEmpresa', this.empresaAtual.id_empresa);
      }

      this.$http.get('chatbot/contatos/' + this.token, {params: this.pesquisa})
        .then(response => {
          this.load = false;
          this.contacts = response.data || [];

        }, res => {
          this.load = false;
          this.$swal(res.data && res.data.msg ? res.data.msg : 'Erro temporário');
        });
    },

    toggleMenuFilter(m) {
      this.pesquisa.relatorio = m;
      this.buscarContatos();
    },

    editarStatus(contato, status) {
      const bkp_status = contato.status;
      const dados = { id_chatbot_user: contato.id_chatbot_user, status };
      contato.status = status;

      this.$http.post('chatbot/contato/status/' + this.token, dados).then(() => {
        this.$refs.contato.editarStatus(dados.id_chatbot_user, status);

      }, res => {
        contato.status = bkp_status;
        this.$swal(res.data && res.data.msg ? res.data.msg : 'Erro temporário');
      });
    },

    editarContato(id_chatbot_user, nome_user) {
      const dados = this.contacts.find(c => c.id_chatbot_user === id_chatbot_user);

      if (dados) {
        dados.nome_user = nome_user;
      }
    },

    selContato(id) {
      this.dados = id;
      this.$refs.contato.selContato(id);
    },

    paginateContacts(page) {
      this.pesquisa.page += page;
      this.buscarContatos();
    },

    selAtendimento(atendimento, ignorar) {
      if (!ignorar) {
        this.acessarWpp(atendimento);
      }

      atendimento.data_atendimento = null;
      this.contacts = this.contacts.filter(c => c !== atendimento);
      this.$store.dispatch('removeAtendimentoEmpresa', {
        idEmpresa: atendimento.id_empresa || (this.empresaAtual || {}).id_empresa,
        idChatbotUser: atendimento.id_chatbot_user
      });

      this.$http.post('chatbot/atendimento/' + this.token, { id_chatbot_user: atendimento.id_chatbot_user })
        .then(response => {

        }, res => {
          this.load = false;
          this.$swal(res.data.msg || 'Erro temporário');
        });
    },

    acessarWpp(dados) {
      if (this.isElectron && !this.session) {
        this.$swal("Não é possível acessar este Chat por que o Bot ainda está sendo iniciado.");
        return;
      }

      if (this.session) {
        window.control.acessarChat({ to: dados.wid || dados.id_user, wpp: this.session.wpp });
        this.$emit('goHome');

      } else {
        window.open('https://wa.me/' + this.$helpers.normalizarTelefone(dados.telefone));
      }
    },

    ignorarTodos() {
      this.$swal({
        text: "Deseja ignorar todos os chamados?",
        buttons: ["Voltar", "Sim"],
        dangerMode: true
      }).then((result) => {
        if (result) {
          this.load = true;
          this.$http.post('chatbot/atendimento/' + this.token, { clear: true }).then(() => {
            this.load = false;
            this.pesquisa.termo = "";
            this.pesquisa.page = 0;
            this.buscarContatos();

          }, res => {
            this.load = false;
            this.$swal(res.data && res.data.msg ? res.data.msg : 'Erro temporário');
          });
        }
      });
    },

    changeEmpresa() {
      this.token = localStorage.getItem('key');
      this.buscarContatos();
    }
  },

  mounted() {
    this.buscarContatos();
  },

  sockets: {
    new_bot() {
      if (this.pesquisa.relatorio === '1' && !this.pesquisa.page) {
        this.buscarContatos();
      }
    },

    request_human() {
      this.buscarContatos();
    }
  },

  computed: {
    session() {
      return this.$store.state.session
    },

    user() {
      return this.$store.state.dataUser
    },

    empresas() {
      return this.$store.state.empresas
    },

    empresaAtual() {
      return this.empresas.find((empresa) => empresa.isDefault) || null;
    },
  }
}
</script>

<style scoped>
.content {
  padding-top: 32px;
  margin-bottom: 0;
}

.lebot-filter {
  padding: 10px 10px 15px;
  border-bottom: 1px solid #dddfeb
}

.lebot-contatos {
  padding: 0;
  border-right: 1px solid #dee2e6;
}

.lebot-contatos-body {
  height: calc(100vh - 188px);
  overflow: auto;
  padding: 0;
}

.lebot-contatos-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 4px 8px;
}

.lebot-contatos-footer .btn {
  color: #6c757d;
}

.lebot-contatos-footer .btn:not(:disabled) {
  color: var(--primary);
}

.lebot-contact {
  display: block;
  padding: 15px;
  border-bottom: 1px solid #dee2e6;
}

.lebot-contact:hover {
  background-color: #F5F6F6;
}

.lebot-contact.selected {
  background-color: #F0F2F5;
}

.lebot-contact .btn {
  width: 42px;
}

.lebot-contact-body {
  width: calc(100% - 70px);
}

.lebot-welcome {
  height: 80vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

.lebot-dados {
  padding: 0 0 24px;
  background-color: #FFFFFF;
  height: calc(100vh - 32px);
  overflow: auto;
}

.menu-card {
  position: absolute;
  top: 58px;
  right: 8px;
  z-index: 99;
  text-align: left;
}

.menu-card .card {
  padding: 8px 0;
  min-width: 180px;
  max-width: 250px;
  max-height: 322px;
  overflow-y: auto;
}

.menu-card .menu-item {
  cursor: pointer;
  padding: 8px 16px;
  border-bottom: 1px solid var(--light);
  text-decoration: none;
  color: var(--dark);
  font-size: 0.9em;
}

.menu-card .menu-item:hover {
  background-color: var(--light);
}

.menu-card .menu-item:last-child {
  border-bottom: none;
}

@media (max-width: 767px) {
  .lebot-filter {
    border-bottom: none;
    padding-bottom: 8px;
  }

  .lebot-contatos {
    border-right: none;
    min-height: 100vh;
  }

  .lebot-contatos.closed {
    display: none;
  }

  .lebot-contatos-body {
    height: auto;
    border: none;
    overflow: visible;
    padding-bottom: 42px;
  }

  .lebot-welcome {
    display: none;
  }

  .lebot-dados {
    display: none;
  }

  .lebot-dados.opened {
    z-index: 1;
    display: block;
    min-height: 100vh;
    height: auto;
    overflow: visible;
  }
}
</style>
